import { LibroTheme } from '../../theme/types';
import { headingCID } from '../Heading';

const CARD_BOTTOM_MARGIN = 5;

export const cardClassIdentifier = 'CID-Card';
export const collapseTextToggleCID = 'CID-CollapseTextToggle';

export const cardStyles = (theme: LibroTheme) => ({
  '&:empty': {
    border: 0,
  },
  backgroundColor: theme.palette.background.paper,
  border: theme.greyBorder,
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 0 25px rgba(0 0 0 / .06)',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(CARD_BOTTOM_MARGIN),
  marginTop: theme.spacing(CARD_BOTTOM_MARGIN),
  [`& .${headingCID}`]: {
    marginTop: '0.25rem',
  },
});
